import { AppState } from '../../rootReducer';

export const templateEditorSelector = (state: AppState) => state.emailMarketing.emailTemplateEditor;
export const templateEditorComponentsSelector = (state: AppState) =>
  state.emailMarketing.emailTemplateEditor.components || [];
export const backgroundColorSelector = (state: AppState): string =>
  state.emailMarketing.emailTemplateEditor.styles.backgroundColor || '#fff';
